'use client';
import React from 'react';

import ListPage from '@/components/page-components/list-page/list-page';
import { createListCardArray } from '@/helpers/list-page/list-page-helpers';
import { pageIsTenantEntertainment } from '@/helpers/list-page/type-guards';
import useGetMobileAppWebViewHeader from '@/hooks/use-get-mobile-app-web-view';
import { IMeetingplacePageHomeMinifiedExtendedAttributeFilters } from '@/lib/fragments/meetingPlacePageHome-minified';
import { IMeetingPlacePageTenantEntertainmentList } from '@/lib/fragments/meetingPlacePageTenantEntertainmentList';
import { IMeetingPlacePageTenantList } from '@/lib/fragments/meetingPlacePageTenantList';
import {
  useGetActiveOffers,
  useTenantConfig,
} from '@/providers/ConfigProvider';
import { GtmPageView } from '@/components/page-components/analytics/gtm-page-view';

interface MeetingPlacePageTenantEntertainmentListProps {
  meetingPlacePageTenantEntertainmentList: IMeetingPlacePageTenantEntertainmentList;
  meetingPlacePageTenantList: IMeetingPlacePageTenantList;
  meetingPlacePageHome: IMeetingplacePageHomeMinifiedExtendedAttributeFilters;
}
const MeetingPlacePageTenantEntertainmentList = ({
  metaData,
  node_locale,
  urlSubdirectory,
  tenantListId,
  data,
  initialPage,
}: any) => {
  const config = useTenantConfig();
  const activeOffers = useGetActiveOffers();
  const prefix = config?.GATSBY_SITE_PATH_PREFIX || '';

  const page = data?.meetingPlacePageTenantEntertainmentList;
  const homepage = data?.meetingPlacePageHomeCollection;

  const entertainmentPagesInTenantList =
    data?.meetingPlacePageTenantList?.tenantsCollection?.items
      ?.filter(Boolean)
      ?.filter((t: any) => pageIsTenantEntertainment(t));

  let entertainmentPages = entertainmentPagesInTenantList
    ? [...entertainmentPagesInTenantList]
    : [];
  page?.entertainmentItemsCollection?.items
    ?.filter(Boolean)
    ?.forEach((page: any) => {
      const pageExists =
        entertainmentPages.filter((item) => item?.sys?.id === page?.sys?.id)
          .length > 0;
      if (!pageExists) entertainmentPages.push(page);
    });

  entertainmentPages = entertainmentPages?.map((item) => {
    const hasOffer = activeOffers?.find(
      (offer: any) => offer?.tenant?.sys?.id == item?.sys?.id,
    );
    const offerCampaignNames = [
      ...new Set(
        activeOffers
          ?.filter((offer: any) => offer?.tenant?.sys?.id == item?.sys?.id)
          .flatMap((o: any) => o?.tags ?? [])
          .filter(Boolean),
      ),
    ] as string[];
    return {
      ...item,
      hasOffer: hasOffer ? true : false,
      ...(offerCampaignNames.length > 0 && { offerCampaignNames }),
    };
  });

  const entertainmentCardList = createListCardArray(
    entertainmentPages,
    undefined,
    undefined,
    urlSubdirectory,
    node_locale || page?.sys?.locale,
    prefix,
  );

  const isWebView = useGetMobileAppWebViewHeader();

  return (
    <>
      {page && (
        <>
          {/* ✅ GTM PAGE VIEW */}
          <GtmPageView
            homepage={homepage}
            language={node_locale}
            pageTitle={page?.name ?? ''}
          />

          <ListPage
            cardList={entertainmentCardList}
            pageName={page?.name}
            pageSlug={page?.slug}
            node_locale={node_locale}
            // location={location}
            breadcrumbs={[page?.name]}
            homeText={homepage?.breadcrumbHomeText}
            tileColClass="grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
            listType="entertainment"
            attributeFilters={homepage?.meetingPlace?.attributeFilters}
            isWebView={isWebView}
            config={config}
            initialPage={initialPage ?? 1}
          />
        </>
      )}
    </>
  );
};

export default MeetingPlacePageTenantEntertainmentList;
